import React, { useState, useEffect } from 'react'
import styles from './Header.module.css'

export default function Header() {
    const [isFixed, setIsFixed] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop =
                window.scrollY || document.documentElement.scrollTop

            if (scrollTop > 560 && !isFixed) {
                setIsFixed(true)
            } else if (scrollTop < 560 && isFixed) {
                setIsFixed(false)
            }
        }

        window.addEventListener('load', handleScroll)
        window.addEventListener('scroll', handleScroll)

        handleScroll()

        return () => {
            window.removeEventListener('load', handleScroll)
            window.removeEventListener('scroll', handleScroll)
        }
    }, [isFixed])

    return (
        <header className={`${styles.header} ${isFixed ? styles.isFixed : ''}`}>
            <nav className={styles.gNav}>
                <a className={styles.logo} href='/'>
                    <img
                        src='/pages/business/foodslabo/logo.png'
                        alt='Foodslaboのロゴ'
                    />
                </a>
                <a className={styles.gNavMenu} href='#form'>
                    お問い合わせ
                </a>
            </nav>
        </header>
    )
}
